export class LiveChatLauncher {
	constructor(state, options = {}) {
		this.state = state;
		this.options = {
			position: options.position || 'right',
			primaryColor: options.primaryColor || '#155EEF',
			...options,
		};
		this.element = null;
		this._unsubscribe = null;
	}

	render() {
		this.element = document.createElement('div');
		this.element.className = `liveChat-launcher liveChat-launcher-${this.options.position}`;

		this._updateContent();
		this._attachEvents();

		this._unsubscribe = this.state.subscribe((type, data) => {
			if (type === 'openChange') {
				this._updateIcon();
			}
			if (type === 'unreadCountChange') {
				this._updateBadge();
			}
		});

		return this.element;
	}

	_updateContent() {
		const badgeHtml =
			this.state.unreadCount > 0
				? `<span class="liveChat-launcher-badge">${this.state.unreadCount > 9 ? '9+' : this.state.unreadCount}</span>`
				: '';

		this.element.innerHTML = `
        <button class="liveChat-launcher-btn" aria-label="Open live chat" aria-expanded="false">
            <span class="liveChat-launcher-icon liveChat-launcher-icon-chat">
                <iconify-icon icon="ph:chats-circle" width="24" height="24"></iconify-icon>
            </span>
            <span class="liveChat-launcher-icon liveChat-launcher-icon-close" style="display: none;">
                <iconify-icon icon="ph:caret-down-bold" width="22" height="22"></iconify-icon>
            </span>
            ${badgeHtml}
        </button>
    `;
	}

	_attachEvents() {
		this.element
			.querySelector('.liveChat-launcher-btn')
			.addEventListener('click', () => {
				this.state.setOpen(!this.state.isOpen);
			});
	}

	_updateIcon() {
		const chatIcon = this.element.querySelector('.liveChat-launcher-icon-chat');
		const closeIcon = this.element.querySelector(
			'.liveChat-launcher-icon-close'
		);

		const btn = this.element.querySelector('.liveChat-launcher-btn');
		if (btn) {
			btn.setAttribute(
				'aria-label',
				this.state.isOpen ? 'Close live chat' : 'Open live chat'
			);
			btn.setAttribute('aria-expanded', String(this.state.isOpen));
		}

		if (this.state.isOpen) {
			chatIcon.style.display = 'none';
			closeIcon.style.display = 'flex';
			this.element.classList.add('liveChat-launcher-open');
		} else {
			chatIcon.style.display = 'flex';
			closeIcon.style.display = 'none';
			this.element.classList.remove('liveChat-launcher-open');
		}
	}

	_updateBadge() {
		const existingBadge = this.element.querySelector(
			'.liveChat-launcher-badge'
		);
		if (existingBadge) {
			existingBadge.remove();
		}

		if (this.state.unreadCount > 0 && !this.state.isOpen) {
			const badge = document.createElement('span');
			badge.className = 'liveChat-launcher-badge';
			badge.textContent =
				this.state.unreadCount > 9 ? '9+' : this.state.unreadCount;
			this.element.querySelector('.liveChat-launcher-btn').appendChild(badge);
		}
	}

	show() {
		if (this.element) {
			this.element.style.display = 'block';
		}
	}

	hide() {
		if (this.element) {
			this.element.style.display = 'none';
		}
	}

	destroy() {
		if (this._unsubscribe) {
			this._unsubscribe();
		}
		if (this.element && this.element.parentNode) {
			this.element.parentNode.removeChild(this.element);
		}
	}
}
